import { SET_CURRENT_RESERVATION, SET_LOADING_STATE, SET_ERROR_CODE } from '../ActionTypes/reservations';
import { ReservationDetails } from '@/types/reservation';
import { ErrorTypes } from '@/services/api/errorCodes';

interface ReservationState {
    selectedReservation: ReservationDetails | null;
    type: string;
    loading: boolean;
    error: ErrorTypes | null;
}

const INIT_STATE: ReservationState = {
    selectedReservation: null,
    loading: false,
    error: null,
    type: ''
};

interface IAction {
    type: string
    reservation: ReservationDetails
    loading: boolean
    error: ErrorTypes
}

export default (state = INIT_STATE, action: IAction): ReservationState => {
    switch (action.type) {
        case SET_CURRENT_RESERVATION: {
            return { ...state, selectedReservation: action.reservation };
        }
        case SET_LOADING_STATE: {
            return { ...state, loading: action.loading };
        }
        case SET_ERROR_CODE: {
            return { ...state, error: action.error };
        }
        default:
            return state;
    }
};
